import $ from "jquery";
import {Modal} from "bootstrap";

export default function () {
    let removeItem = null;
    if ($('.item-remove').length) {
        $('body').on('click', '.item-remove', function () {
            removeItem = $(this).parents('.accordion-item').find('.accordion-collapse').data("id");
        });
    }

    const $removeModal = $('#removeModal');
    const $confirm = $removeModal.find('.confirm');
    const $dismiss = $removeModal.find('.dismiss');
    $confirm.on('click', function () {
        const $accordion = $('.accordion-collapse[data-id=' + removeItem + ']').parents('.accordion-item');
        const productsAccordionItems = document.querySelectorAll('#productsAccordion .accordion-item');

        $dismiss.trigger('click');

        if (typeof productsAccordionItems[removeItem + 1] !== "undefined") {
            let elem = productsAccordionItems[removeItem + 1];
            if ($(elem).find('input[data-name=first_product_info]').is(':checked')) {
                const myModal = new Modal('#removeConfirmWithFlagModal');
                myModal.show();
                return;
            }
        } else if(removeItem === window.lastProduct) {
            //sto eliminando l'ultimo prodotto
            window.lastProduct--;
        }

        $accordion.remove();

        remove(removeItem);

        if (!$('.accordion-item').length) {
            location.reload();
        }
    });

    const $removeConfirmWithFlagModal = $('#removeConfirmWithFlagModal');
    if ($removeConfirmWithFlagModal.length) {
        const $confirmWFM = $removeConfirmWithFlagModal.find('.confirm');
        const $dismissWFM = $removeConfirmWithFlagModal.find('.dismiss');
        $confirmWFM.on('click', function () {
            const $accordion = $('.accordion-collapse[data-id=' + removeItem + ']').parents('.accordion-item');
            const productsAccordionItems = document.querySelectorAll('#productsAccordion .accordion-item');
            let elem = productsAccordionItems[removeItem + 1];
            $dismissWFM.trigger('click');
            $accordion.remove();

            $(elem).find('input[data-name=first_product_info]').prop('checked', false).change();
            if (removeItem === 0) {
                $(elem).find('.first-product-info-wrap').addClass('d-none');
            }

            remove(removeItem);

            if ($(elem).find('.accordion-button').attr('aria-expanded') === "false") {
                $(elem).find('.accordion-button').click();
            }
        });
    }
}

function remove(removeItem) {
    $.ajax({
        url: removeProductUrl,
        method: "POST",
        data: {
            id: removeItem
        },
        success: function (result) {
        },
        error: function (xhr) {
        }
    });
}
